module.exports = __webpack_public_path__ + "assets/img/success.3360ac4d.svg";